<template>


    <form :action="actionPage" method="post" name="donation_form">

        <input :value="csrf_token" name="_token" type="hidden">
        <input :value="avoid_duplicate" name="avoid_duplicate" type="hidden">
        <input :value="marxism.title" name="event_name" type="hidden">

        <table class="c-form-table-2  js-step-container">
            <tbody>
            <tr>
                <th nowrap><label for="name">이름*</label></th>
                <td>
                    <input class="u-12/12" id="name" name="name" required type="text"
                           v-model="name">
                </td>
            </tr>
            <tr>
                <th nowrap><label for="is_member_of">소속</label></th>
                <td>
                    <input class="u-12/12" id="is_member_of" name="is_member_of" type="text"
                           v-model="is_member_of">
                    <div class="u-text-small">
                        (직장/학교/단체/노동조합 등)
                    </div>
                </td>
            </tr>
            <tr>
                <th nowrap><label for="phone">휴대폰*</label></th>
                <td>
                    <input class="u-12/12" id="phone" name="phone" pattern="[0-9\-]+" placeholder="010-1234-1234"
                           required
                           title="숫자와 -만 입력하세요." type="text"
                           v-model="phone">
                </td>
            </tr>
            <tr>
                <th nowrap><label for="email">이메일*</label></th>
                <td>
                    <div class="u-margin-bottom-tiny">
                        <input class="u-12/12" id="email" name="email" placeholder="your-mail@test.com" required
                               type="email"
                               v-model="email">
                    </div>
                </td>
            </tr>
            <tr>
                <th>금액</th>
                <td class="u-text-keep-words">
                    <p>
                        <input @blur="amount = amount || 0" @focus="$event.target.select()"
                               class="u-text-right  u-3/12" id="amount"
                               name="amount" pattern="[0-9]*"
                               title="숫자만 입력해 주세요."
                               type="text"
                               v-model="amount">원
                    </p>

                </td>
            </tr>
            <tr>
                <th nowrap><label for="remark">문의/남길말</label></th>
                <td>
                    <textarea class="u-12/12" id="remark" name="remark" rows="3" v-model="remark"></textarea>
                </td>
            </tr>
            <tr>
                <th nowrap>지불 방법</th>
                <td>
                    <label>
                        <input name="pay_method" type="radio" v-model="pay_method" value="카드">
                        카드
                    </label>
                    <label>
                        <input name="pay_method" type="radio" v-model="pay_method" value="계좌이체">
                        계좌이체
                    </label>
                </td>
            </tr>
            <tr v-if="pay_method === '계좌이체'">
                <th nowrap>
                    <label for="nominee">입금자명</label>
                </th>
                <td>
                    <input class="u-12/12" id="nominee" name="nominee" required type="text"
                           v-model="nominee">
                    <button @click="nominee = name" class="c-btn  c-btn--default  c-btn--size-small u-text-tiny"
                            type="button">
                        이름과 같음
                    </button>
                </td>
            </tr>
            <tr v-if="pay_method === '계좌이체'">
                <td colspan="2">
                    보낼 계좌: 국민은행 206001-04-033205 (백은진)
                    <input name="bank" type="hidden" v-model="bank" value="국민은행">
                </td>
            </tr>
            <tr v-if="pay_method === '계좌이체'">
                <th nowrap>
                    이체 예정일
                </th>
                <td>
                    <div class="o-show-date-calendar">
                        <input :max="max_date_of_direct" :min="min_date_of_direct" id="pay_due" name="pay_due"
                               required
                               type="date"
                               v-model="pay_due">
                    </div>
                </td>
            </tr>
            </tbody>
        </table>



        <p class="u-text-center" v-if="app_env === 'local'">
            <button @click="test()" type="button">테스트 입력</button>
        </p>

        <p class="u-text-center">
            <button class="c-btn c-btn--primary  c-btn--size-large" type="submit">
                후원하기
            </button>
        </p>
    </form>

</template>

<script>
    export default {
        name: "DonationForm",
        props: ['marxism'],
        data() {
            return {
                avoid_duplicate: Math.random().toString(36).slice(2),
                csrf_token: document.querySelector('[name="csrf-token" ]').content,
                app_env: $('#app_env').content,

                name: '',
                is_member_of: '',
                phone: '',
                email: '',
                amount: 10000,
                pay_method: '카드',
                remark: '',
                nominee: '',
                bank: '국민은행',
                pay_due: moment().format('YYYY-MM-DD'),
                event_name: marxism.title,
                min_date_of_direct: moment().format('YYYY-MM-DD'),
                max_date_of_direct: moment().add(7, 'day').format('YYYY-MM-DD'),
            }
        },
        computed: {
            actionPage() {
                if (this.pay_method === '카드') {
                    return '/donation/bridge';
                } else if (this.pay_method === '계좌이체') {
                    return '/donation/direct';
                }
            }
        },
        methods: {
            test() {
                this.name = '테스트';
                this.is_member_of = '소속';
                this.phone = '010-1234-1234';
                this.email = 'test@test.com';
                this.amount = 1000;
                this.pay_method = '카드';
                this.remark = "즐거운 맑시즘이 되길 기원합니다.\n기대하고 있겠습니다.";
            },
        }
    }
</script>
